import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { FileFormModel } from 'src/app/+drr-ccd-devices/technical-data/technical-data.domain';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-file-input-form-control',
  templateUrl: './file-input-form-control.component.html',
  styleUrls: ['./file-input-form-control.component.scss', '../../styles/custom-control.styles.scss'],
})
export class FileInputFormControlComponent extends DestroyableComponent implements OnInit {
  form: FormGroup;

  @Input() label: string;
  @Input() documentType: string;
  @Input() required: boolean;
  @Input() data: FileFormModel;
  @Input() clearOn: Observable<boolean>;

  private _disabled: boolean;
  public get disabled(): boolean {
    return this._disabled;
  }
  @Input()
  public set disabled(value: boolean) {
    this._disabled = value;
    this._disabled ? this.form.disable() : this.form.enable();
    if (this._disabled) {
      this.required = false;
    } else if (this.form.controls.name.validator) {
      const fn = this.form.controls.name.validator({} as AbstractControl);
      this.required = fn?.required;
    }
    this.cd.detectChanges();
  }

  @Output() formInited = new EventEmitter<FormGroup>();

  constructor(private fb: FormBuilder, private fileService: FileService, private cd: ChangeDetectorRef) {
    super();
    this.form = this.fb.group({
      id: this.fb.control(null),
      name: this.fb.control(null),
      file: this.fb.control(null),
      documentType: this.fb.control(this.documentType),
      contentType: this.fb.control(null),
    });
  }

  ngOnInit(): void {
    this.form.patchValue({
      documentType: this.documentType,
    });

    if (this.data?.id) {
      this.form.controls.file.disable();
    }

    if (this.data) {
      this.form.patchValue(this.data);
    }

    if (this.required) {
      this.form.controls.name.setValidators([Validators.required]);
      this.form.controls.name.updateValueAndValidity();
    }

    this.formInited.emit(this.form);
    this.clearOn?.subscribe(isClear => isClear && this.clear());
  }

  upload(data: any) {
    this.clear(); // clear any existing values
    const file = data.currentFiles[0] as File;
    this.form.controls.file.setValue(file);
    this.form.controls.name.setValue(file.name);
    this.form.controls.contentType.setValue(file.type);
  }

  openFile() {
    const file = this.form.controls.file.value as File;
    const fileName = this.form.controls.name.value as string;
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  download() {
    const documentId = this.form.controls.id.value;
    this.preventLeak(this.fileService.readWorkflowDocument(documentId)).subscribe(async (response: Blob) => {
      this.fileService.downloadDocument(response, this.form.controls.name.value, false);
    });
  }

  clear() {
    this.form.controls.id.setValue(null);
    this.form.controls.name.setValue(null);
    this.form.controls.file.setValue(null);
    this.form.controls.contentType.setValue(null);
    this.data = null;
    this.form.controls.file.enable();
  }

  blobToFile(blob: Blob, fileName: string, mimeType?: string): File {
    return new File([blob], fileName, { type: mimeType || blob.type });
  }
}

export const emptyFileInputFormValue = {
  id: null,
  name: null,
  file: null,
  documentType: null,
  contentType: null,
};

export function createEmptyFileInputFormValue(documentType: string) {
  return { ...emptyFileInputFormValue, documentType: documentType };
}
